import { useEffect, useState } from 'react';
import { RenderInput, renderStaticString } from '../gpu'
import { browserName, isIOS } from 'react-device-detect';

const getFirstLocalVoice = (speechSynthesis: SpeechSynthesis, local: string): SpeechSynthesisVoice | null => {
    const voices = speechSynthesis.getVoices()

    return voices.sort((a, b) => {
        if (a.lang.toLocaleLowerCase() === local) return -1
        if (b.lang.toLocaleLowerCase() === local) return 1
        if (a.default) return -1
        return 0
    })[0] || null

}

type Options = {
    pitch: number,
    rate: number,
    volume: number,
}

const getDefaultOptions = (): Options => {
    switch (true) {
        case isIOS:
            return {
                pitch: 1,
                rate: 1.04,
                volume: 0.7,
            }
        case browserName === 'Chrome':
            return {
                pitch: 0.35,
                rate: 1,
                volume: 0.7,
            }
        case browserName === 'Firefox':
            return {
                pitch: 1.35,
                rate: 1.05,
                volume: 0.7,
            }

        default:
            return {
                pitch: 1,
                rate: 1.01,
                volume: 0.7,
            }
    }
}

const useTTS = (
    locale = 'en-us', 
    options: Options = getDefaultOptions(),
    onError: (error: SpeechSynthesisErrorEvent) => void = () => {}
) => {
    const speechSynthesis = window.speechSynthesis;
    const [voice, setVoice] = useState<SpeechSynthesisVoice | null>(null)

    const cancel = () => {
        speechSynthesis.cancel()
    }

    useEffect(() => {
        setVoice(getFirstLocalVoice(speechSynthesis, locale))
    })

    const say = (render: RenderInput) => {
        if (voice === null) return

        const text = renderStaticString(render).replace( /\s\s+/g, ' ' ).replace('█', '')
        let utterance = new SpeechSynthesisUtterance(text)
        
        //utterance.voice = voices[12]  
        utterance.voice = voice 
        utterance.pitch = options.pitch
        utterance.rate = options.rate
        utterance.volume = options.volume
        utterance.lang = 'en-US'

        utterance.onerror = (error) => {
            if (error.error === "interrupted") return
            onError(error)
            console.error(`TTS Error: ${error.error}`, error)
        }

        speechSynthesis.speak(utterance)
    }

    return {
        say,
        cancel
    }
}

export default useTTS